import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Thin wrapper for the standard Admin Delete action.
 * Composes app-button with danger variant and shared defaults.
 */
@Component({
  selector: 'app-admin-delete-button',
  templateUrl: './admin-delete-button.component.html',
  styleUrls: ['./admin-action-button.scss'],
  host: {
    '[class]': 'hostClass',
  },
})
export class AdminDeleteButtonComponent {
  /** Host-level layout classes (e.g. float-right) */
  @Input() hostClass = '';
  /** Translation key for the button label */
  @Input() labelKey = 'admin.global.delete';
  /** Optional test id forwarded to the rendered button */
  @Input() dataTestid = 'delete-button';
  @Input() disabled = false;
  /** Additional CSS classes for the inner button element */
  @Input() classes = '';
  @Input() startIcon = 'fa-trash';
  @Input() size: 'small' | 'medium' | 'large' | 'default' = 'medium';

  @Output() delete = new EventEmitter<Event>();

  onClick(event: Event): void {
    this.delete.emit(event);
  }
}
